import React from 'react';
import './HomeNav.css';
import EntityProjectsContext from '../../../EntityProjects/context/EntityProjects.context';
import { useContext } from 'react';

export const HomeNav = ({ menus, setActiveIndex, activeIndex }) => {
    const { infos } = useContext(EntityProjectsContext);
    
    const handleTabClick = (index) => {
        setActiveIndex(index);
    };

    return (
        <div className="tabs">
            {menus.map((menu, index) => (
                <div
                    key={index}
                    className={`tab ${activeIndex === menu.index ? 'active' : ''}`}
                    style={(activeIndex === menu.index) ? {
                        borderBottom: `2px solid ${infos.primary_color}`,
                        color: infos.primary_color
                    } : {}}
                    onClick={() => handleTabClick(menu.index)}
                >
                    {menu.title}
                </div>
            ))}
        </div>
    );
};
